import Field from "./Field";
import DanfeHeader from "./DanfeHeader";
import DanfeItemsTable from "./DanfeItemsTable";
import { useTranslation } from "react-i18next";

const DanfeFirstPage = ({ data, folha }) => {
  const { t } = useTranslation();

  return (
    <div className="danfe-page">
      <div className="danfe-receipt">
        <div className="danfe-receipt-top">
          {t("danfe.messageReceipt", {
            nameEmit: data.emitente.nome,
            date: data.destinatario.dataEmissao,
            totalValue: data.imposto.valorNota,
            nameDest: data.destinatario.nome,
          }).toUpperCase()}
        </div>
        <div className="danfe-receipt-bottom">
          <div className="receipt-col">
            {t("danfe.dateReceipt").toUpperCase()}
          </div>
          <div className="receipt-col">
            {t("danfe.identSing").toUpperCase()}
          </div>
          <div className="receipt-nf-box">
            <div className="receipt-nf-title">{t("danfe.nfe")}</div>
            <div className="receipt-nf-number">
              {t("danfe.number")} {data.numero}
            </div>
            <div className="receipt-nf-serie">
              {t("danfe.serie")} {data.serie}
            </div>
          </div>
        </div>
      </div>

      <div className="dashed-line" />

      <DanfeHeader data={data} folha={folha} />

      <div className="section-title">{t("danfe.destReme")}</div>

      <div className="danfe-row">
        <Field
          label={t("danfe.companyName").toUpperCase()}
          value={data.destinatario.nome}
          className="w-61 bold-value"
        />
        <Field
          label={t("danfe.cnpj")}
          value={data.destinatario.cnpj}
          className="w-20 bold-value"
        />
        <Field
          label={t("danfe.dateIssue")}
          value={data.destinatario.dataEmissao}
          className="w-19 bold-value"
        />
      </div>

      <div className="danfe-row">
        <Field
          label={t("danfe.address")}
          value={data.destinatario.endereco}
          className="w-45 bold-value"
        />
        <Field
          label={t("danfe.neighborhood")}
          value={data.destinatario.bairro}
          className="w-20 bold-value"
        />
        <Field
          label={t("danfe.cep")}
          value={data.destinatario.cep}
          className="w-16 bold-value"
        />
        <Field
          label={t("danfe.arrivalDate")}
          value={data.destinatario.dataSaida}
          className="w-19 bold-value"
        />
      </div>

      <div className="danfe-row">
        <Field
          label={t("danfe.local")}
          value={data.destinatario.municipio}
          className="w-38 bold-value"
        />
        <Field
          label={t("danfe.uf")}
          value={data.destinatario.uf}
          className="w-5 bold-value"
        />
        <Field
          label={t("danfe.fone")}
          value={data.destinatario.foneFax}
          className="w-19 bold-value"
        />
        <Field
          label={t("danfe.ie")}
          value={data.destinatario.ie}
          className="w-19 bold-value"
        />
        <Field
          label={t("danfe.arrivalTime")}
          value={data.destinatario.horaSaida}
          className="w-19 bold-value"
        />
      </div>

      <div className="section-title">{t("danfe.invoce")}</div>

      <div className="danfe-dup-container">
        {data.faturas.map((item) => (
          <div className="dup-group" key={item.numero}>
            <Field label={t("danfe.num")} value={item.numero} />
            <Field label={t("danfe.dueDates")} value={item.vencimento} />
            <Field
              label={t("danfe.value")}
              value={item.valor}
              className="bold-value"
            />
          </div>
        ))}
      </div>

      <div className="section-title">{t("danfe.taxCalculation")}</div>

      <div className="danfe-row">
        <Field
          label={t("danfe.bicms")}
          value={data.imposto.baseIcms}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vicms")}
          value={data.imposto.valorIcms}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.bicmsst")}
          value={data.imposto.baseIcmsSt}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vicmsst")}
          value={data.imposto.valorIcmsSt}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vii")}
          value={data.imposto.valorImportacao}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vicmsufr")}
          value={data.imposto.valorIcmsUfRemet}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vicmsufd")}
          value={data.imposto.valorFcpUfDest}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.totalValueP")}
          value={data.imposto.valorProdutos}
          className="w-16 bold-value"
        />
      </div>

      <div className="danfe-row">
        <Field
          label={t("danfe.shippingCost")}
          value={data.imposto.valorFrete}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.insuranceValue")}
          value={data.imposto.valorSeguro}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.discount")}
          value={data.imposto.desconto}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.otherExpenses")}
          value={data.imposto.outrasDespesas}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vipi")}
          value={data.imposto.valorIpi}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.vicmsufd")}
          value={data.imposto.valorIcmsUfDest}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.totalTaxedVvalue")}
          value={data.imposto.valorTributos}
          className="w-12 bold-value"
        />
        <Field
          label={t("danfe.totalValue")}
          value={data.imposto.valorNota}
          className="w-16 bold-value"
        />
      </div>

      <div className="section-title">{t("danfe.transporter")}</div>

      <div className="danfe-row">
        <Field
          label={t("danfe.companyName")}
          value={data.transportador.nome}
          className="w-38 bold-value"
        />
        <Field
          label={t("danfe.shippingCosts")}
          value={data.transportador.freteConta}
          className="w-18 bold-value"
        />
        <Field
          label={t("danfe.anttCode")}
          value={data.transportador.codigoAntt}
          className="w-16"
        />
        <Field
          label={t("danfe.vehiclePlate")}
          value={data.transportador.placa}
          className="w-16 bold-value"
        />
        <Field
          label={t("danfe.uf")}
          value={data.transportador.ufPlaca}
          className="w-5 bold-value"
        />
        <Field
          label={t("danfe.cnpj")}
          value={data.transportador.cnpjCpf}
          className="w-19 bold-value"
        />
      </div>

      <div className="danfe-row">
        <Field
          label={t("danfe.address")}
          value={data.transportador.endereco}
          className="w-43 bold-value"
        />
        <Field
          label={t("danfe.local")}
          value={data.transportador.municipio}
          className="w-26 bold-value"
        />
        <Field
          label={t("danfe.uf")}
          value={data.transportador.uf}
          className="w-6 bold-value"
        />
        <Field
          label={t("danfe.ie")}
          value={data.transportador.ie}
          className="w-26 bold-value"
        />
        {/* <Field label="" value="" className="w-18" /> */}
      </div>

      <div className="danfe-row">
        <Field
          label={t("danfe.qty")}
          value={data.transportador.quantidade}
          className="w-20 bold-value"
        />
        <Field
          label={t("danfe.species")}
          value={data.transportador.especie}
          className="w-20 bold-value"
        />
        <Field
          label={t("danfe.mark")}
          value={data.transportador.marca}
          className="w-20"
        />
        <Field
          label={t("danfe.numbering")}
          value={data.transportador.numeracao}
          className="w-20"
        />
        <Field
          label={t("danfe.grossWeight")}
          value={data.transportador.pesoBruto}
          className="w-20 bold-value"
        />
        <Field
          label={t("danfe.netWeight")}
          value={data.transportador.pesoLiquido}
          className="w-20 bold-value"
        />
      </div>

      <div className="section-title">{t("danfe.productData")}</div>
      <DanfeItemsTable items={data.itemsPages[0]} />

      <div className="section-title">
        {t("danfe.additionalData").toUpperCase()}
      </div>
      <div className="danfe-row">
        <Field
          label={t("danfe.additionalInformation")}
          value={data.dadosAdicionais.observacoes}
          className="w-66 additional-box"
        />
        <Field
          label={t("danfe.reservedTaxAuth")}
          value={data.dadosAdicionais.reservadoFisco}
          className="w-34 additional-box"
        />
      </div>

      <div className="page-footer">
        <div>
          {t("danfe.printedIn")} {data.dadosAdicionais.rodapeDir}
        </div>
        <div>{data.dadosAdicionais.rodapeSistema}</div>
      </div>
    </div>
  );
};

export default DanfeFirstPage;
